import { OrgSelectLocale } from "../index";

const locale: OrgSelectLocale = {
  placeholder: 'click to search',
  title: "organizational search",
};

export default locale
